<template>
  <section class="landing-page">
    <div class="banner-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <b-navbar toggleable="lg" type="dark">
              <a class="navbar-brand" href="/"><img class="img-fluid" src="@/assets/logo_tnc-cup_dark.png" alt="tnc-cup home"></a>
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav  class="ml-auto">
                <b-nav class="navbar-nav">
                  <b-nav-item to="/">HOME</b-nav-item>
                  <b-nav-item href="https://www.talkncloud.com" target="_blank">BLOG</b-nav-item>
                  <b-nav-item href="https://github.com/talkncloud/tnc-cup-client" target="_blank">DOCO <i class="mdi mdi-github-circle"></i></b-nav-item>
                  <b-nav-item to="signin" v-if="!signedIn">SIGN IN</b-nav-item>
                  <b-nav-item to="dashboard" v-if="signedIn">DASHBOARD</b-nav-item>
              </b-nav>
                </b-navbar-nav>
                <!-- Right aligned nav items -->
              </b-collapse>
            </b-navbar>
          </div>
        </div>
        <!--<div class="ribbon ribbon-top-right"><span>GA</span></div>-->
        <div class="row py-sm-5 py-0">
          <div class="col-lg-7 banner-content">
            <h1 class="mr-2 text-white"> AWS cloud price estimation at the command line with support for cloudformation, CDK  and CI/CD. </h1>
            <h3 class="font-weight-light text-white pt-2 pb-5"> talkncloud checkup aka tcup</h3>
            <div class="my-5">
              <b-link to="signup" class="btn btn-gradient-primary btn-lg mr-2 mb-3">SIGN UP</b-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 pb-3">
            <div class="card card-icon-top">
              <div class="card-body text-center">
                <b-button class="btn-gradient-danger btn-rounded btn-icon card-icon">
                  <i class="mdi mdi-cloud"></i>
                </b-button>
                <h4>Cloud Native</h4>
                <p class="card-text"> Built using the latest tech and design, we are cloud native, ready to scale and adapt. </p>
              </div>
            </div>
          </div>
          <div class="col-sm-4 pb-3">
            <div class="card card-icon-top">
              <div class="card-body text-center">
                <b-button class="btn-gradient-info btn-rounded btn-icon card-icon">
                  <i class="mdi mdi-shield"></i>
                </b-button>
                <h4>Secure</h4>
                <p class="card-text"> Flexible data model, plus the usual encryption standards and authentication. </p>
              </div>
            </div>
          </div>
          <div class="col-sm-4 pb-3">
            <div class="card card-icon-top">
              <div class="card-body text-center">
                <b-button class="btn-gradient-success btn-rounded btn-icon card-icon">
                  <i class="mdi mdi-account-multiple"></i>
                </b-button>
                <h4>Community Driven</h4>
                <p class="card-text"> You call the shots, tcup is driven by the community, join the team! </p>
              </div>
            </div>
          </div>
        </div>


        <div class="row pt-5">
          <div class="col-md-12 pb-5 pt-5 text-center">
            <h1>Get Started</h1>
          </div>
        <div class="col-md-2 col-lg-2">
        </div>
        <div class="col-md-8 col-lg-8 grid-margin stretch-card mt-0">
          <div class="card remove-background">
            <div class="card-body">
              <ul class="bullet-line-list big-circles">
                <li>
                  <h3 class="ml-5">Grab the npm package</h3>
                  <p class="h4 ml-5">The npm client can be installed locally on your desktop, cloud or build systems.</p>
                  <p class="text-warning ml-5">
                    npm install -g @talkncloud/tcup
                  </p>
                  <p class="text-muted ml-5">
                    <i class="mdi mdi-link"></i> <a href="https://github.com/talkncloud/tnc-cup-client" target="_blank">https://github.com/talkncloud/tnc-cup-client</a></p>
                </li>
                <li>
                  <h3 class="ml-5">Signup</h3>
                  <p class="h4 ml-5">We've taken the hard work out of pricing and provide an API, sign up to grab a key for the client (or develop your own client).</p>
                  <p class="text-muted ml-5">
                    <i class="mdi mdi-currency-usd"></i> Free tier available</p>
                </li>
                <li>
                  <h3 class="ml-5">Let 'er rip</h3>
                  <p class="h4 ml-5">Now simply run the tnc-cup cli tool against a cloudformation template and view the results.</p>
                  <p class="text-muted ml-5">
                    <i class="mdi mdi-code-braces"></i> Add some automation with CI/CD and tcup budgets</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-lg-2">
        </div>
        </div>


        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <h1>Sweet terminal display</h1>
          </div>
          <img center src="@/assets/tnc-cup-client-sample.png" class="img-fluid rounded pb-5" alt="tnc-cup client example">
          <p class="text-muted text-center">
            <i class="mdi mdi-code-braces"></i> Access the raw JSON output via the dedicated API
          </p>
        </div>


        <div class="row pt-5">
          <div class="col-md-12 pb-5 text-center">
            <h1>Top Features</h1>
          </div>
          <div class="feature-list pt-5">
            <div class="row feature-list-row text-center border-bottom">
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-console-line"></i>
                <h3>Terminal package</h3>
                <p class="feature-description">Pre-built npm package ready to check your templates.</p>
              </div>
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-code-braces"></i>
                <h3>CI/CD friendly</h3>
                <p class="feature-description">Add to your exisiting CI/CD to pass or fail on budgets.</p>
              </div>
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-earth"></i>
                <h3>Multi-region</h3>
                <p class="feature-description">Support for multiple AWS regions, easy to configure.</p>
              </div>
              <div class="col-lg-3 feature-list-item">
                <i class="mdi mdi-api"></i>
                <h3>Access the API</h3>
                <p class="feature-description">Use the provided cli or roll your own with our API.</p>
              </div>
            </div>
            <div class="row feature-list-row text-center">
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-select-compare"></i>
                <h3>Filter</h3>
                <p class="feature-description">Secure your data through filters, only what you permit is processed.</p>
              </div>
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-pencil-outline"></i>
                <h3>Easy to customize</h3>
                <p class="feature-description">Local familiar configuration files and options.</p>
              </div>
              <div class="col-lg-3 feature-list-item border-right">
                <i class="mdi mdi-cash-usd-outline"></i>
                <h3>Currency Conversion</h3>
                <p class="feature-description">We support 160+ currencies so that you can understand costs in your currency.</p>
              </div>
              <div class="col-lg-3 feature-list-item">
                <i class="mdi mdi-receipt"></i>
                <h3>Detailed documentation</h3>
                <p class="feature-description">We have made detailed documentation, for ease of use.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="border-bottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-4">
              <img class="img-fluid" src="@/assets/logo_tnc-cup_dark.png" alt="">
              <div class="d-flex pt-5 pb-5">
                <button @click="reddit()" target="_blank" class="btn btn-social-icon btn-reddit"><i class="mdi mdi-reddit"></i></button>
                <button @click="linkedin()" class="btn btn-social-icon btn-linkedin"><i class="mdi mdi-linkedin"></i></button>
                <button @click="github()" type="button" class="btn btn-social-icon btn-github"><i class="mdi mdi-github-circle"></i></button>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="d-flex">
                <h6 class="font-weight-normal">checkup@talkncloud.com</h6>
              </div>
              <ul class="nav mt-3">
                <li class="nav-item">
                  <b-link class="nav-link pl-0 text-uppercase" to="privacy">Privacy Policy</b-link>
                </li>
                <li class="nav-item">
                  <b-link class="nav-link text-uppercase" to="terms">Terms & Conditions</b-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mt-3 mb-2">
          <div class="col-sm-8">
            <h4 class="mt-0">Copyright &copy; {{ new Date().getFullYear() }} <a href="https://www.talkncloud.com" target="_blank">tcup & talkncloud</a>. All rights reserved.</h4>
          </div>
          <div class="col-sm-4">
            <h4>A talkncloud project <img class="ml-1" style="width: 30px" src="@/assets/logo_tnc_foot.png"/>
            </h4>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
import { Auth, Hub } from 'aws-amplify'

export default {
  name: 'landing-page',
  data() { 
    return {
      signedIn: null
    }
  },
  methods:{
    reddit: function () {   
        window.open("https://www.reddit.com/u/talkncloud_mick", "_blank");    
    },
    linkedin: function () {   
        window.open("https://www.linkedin.com/in/michael-jacobsson/", "_blank");    
    },
    github: function () {   
        window.open("https://github.com/talkncloud/tnc-cup-client", "_blank");    
    },
    signOut: () => {
      //console.log("HelloWorld signOut()");
      Auth.signOut()
        .then(data => {
          return
          //console.log(data);
        })
        .catch(err => {
          //console.log(err)
          return
        });
    }
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(() => {
        this.signedIn = true
      })
      .catch(() => this.signedIn = false)
  },
}


</script>